var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgExpiredWarning(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 10,
    viewBox: "0 0 12 10",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M9.95892 9.21045H1.26867C0.380024 9.21045 -0.173936 8.32672 0.270386 7.62291L4.61551 0.738305C5.05983 0.0344974 6.16775 0.0344974 6.61208 0.738305L10.9572 7.62291C11.4015 8.32672 10.8476 9.21045 9.95892 9.21045ZM5.61379 5.5062C5.93117 5.5062 6.19084 5.26807 6.19084 4.97702V3.91867C6.19084 3.62762 5.93117 3.38949 5.61379 3.38949C5.29642 3.38949 5.03675 3.62762 5.03675 3.91867V4.97702C5.03675 5.26807 5.29642 5.5062 5.61379 5.5062ZM5.03675 7.62291H6.19084V6.56456H5.03675V7.62291Z",
    fill: "#203D5E"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExpiredWarning);
export default __webpack_public_path__ + "static/media/expired-warning.f0ba175d0a152cb6dc35bc6761f3851e.svg";
export { ForwardRef as ReactComponent };